import { createContext, useContext } from "react";

/**
 * Which app's quiz this admin screen is editing (multi-app backend).
 * Every tab reads { configKey, bank } and scopes its API calls with them:
 *   configKey → /quiz-config/?configKey=  (config, stats, readiness)
 *   bank      → question endpoints (generate/import bodies, questions filter)
 * Adding a future app or track = one more entry in BANKS (backend:
 * app_registry.py APPS[...].tracks — each track is one config_key + bank).
 */
export const BANKS = [
  {
    value: "english",
    label: "MiniPix — English",
    configKey: "default",
    bank: "english",
    types: ["translation", "fill_blank", "synonym", "antonym", "grammar"],
    bilingual: false,
  },
  {
    value: "reasoning",
    label: "MiniPix Quiz — Reasoning",
    configKey: "reasoning",
    bank: "reasoning",
    types: [
      "series",
      "analogy",
      "odd_one_out",
      "logical_deduction",
      "arithmetic",
      "direction_sense",
      "blood_relation",
      "coding_decoding",
      "general",
    ],
    bilingual: true,
  },
  {
    // MiniPix Math app (com.minipix.math, app_id minipix_math) — a fresh copy
    // of the quiz app trialling another ad network. Bilingual like reasoning;
    // every generated item also carries `expression`, which setu re-evaluates
    // against the keyed option before the draft lands.
    value: "math",
    label: "MiniPix Math — Math",
    configKey: "math",
    bank: "math",
    types: [
      "arithmetic",
      "percentage",
      "ratio_proportion",
      "profit_loss",
      "simple_interest",
      "average",
      "number_system",
      "time_speed_distance",
      "time_work",
      "algebra_basic",
    ],
    bilingual: true,
    verifiedMath: true,
  },
];

export const BankContext = createContext(BANKS[0]);

export const useBank = () => useContext(BankContext);
